import { render } from "./levelUpgradeBanner.vue?vue&type=template&id=f005b518&scoped=true"
import script from "./levelUpgradeBanner.vue?vue&type=script&lang=js"
export * from "./levelUpgradeBanner.vue?vue&type=script&lang=js"

import "./levelUpgradeBanner.vue?vue&type=style&index=0&id=f005b518&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f005b518"]])

export default __exports__